import { Injectable } from '@angular/core';
import { SortDetails } from '../models/sort-details-model';

const COLUMNS_KEY = 'aps_table_columns';
const SORT_KEY = 'aps_sort_state';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {

  saveColumns(fieldNames: string[]): void {
    try {
      localStorage.setItem(COLUMNS_KEY, JSON.stringify(fieldNames));
    } catch { /* localStorage unavailable — fail silently */ }
  }

  loadColumns(): string[] | null {
    try {
      const raw = localStorage.getItem(COLUMNS_KEY);
      if (!raw) { return null; }
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }

  saveSort(sort: SortDetails): void {
    try {
      localStorage.setItem(SORT_KEY, JSON.stringify(sort));
    } catch { /* localStorage unavailable — fail silently */ }
  }

  loadSort(): SortDetails | null {
    try {
      const raw = localStorage.getItem(SORT_KEY);
      if (!raw) { return null; }
      const parsed = JSON.parse(raw) as SortDetails;
      return (parsed && parsed.field) ? parsed : null;
    } catch {
      return null;
    }
  }

  clearSort(): void {
    try {
      localStorage.removeItem(SORT_KEY);
    } catch { /* localStorage unavailable — fail silently */ }
  }

  clearAll(): void {
    try {
      localStorage.removeItem(COLUMNS_KEY);
      localStorage.removeItem(SORT_KEY);
    } catch { /* localStorage unavailable — fail silently */ }
  }
}
